"use client";

import type { PropsWithChildren } from "react";

import type { SvgIcon } from "../../components/icons/type";
import cn from "../../utils/cn.util";
import { useCardContext } from "./context";
import { bodyTitleStyles } from "./styles";

export type BodyTitleProps = {
  className?: string;
  icon?: SvgIcon;
} & PropsWithChildren;

export const BodyTitle = ({ children, className, icon: Icon }: BodyTitleProps) => {
  const { variant } = useCardContext();
  return (
    <div className="flex items-center gap-2">
      {Icon && <Icon className={cn("h-5 w-5 shrink-0 text-neutral-50")} />}
      <h2 className={cn(bodyTitleStyles({ variant }), className)}>{children}</h2>
    </div>
  );
};

export default BodyTitle;
